import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=713fa8db"
import script from "./ActionButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports